export default __webpack_public_path__ + "static/media/Head_6_Ear_1_C2.87619d03.svg";